import { Component, OnInit, AfterViewInit } from "@angular/core";
import { SchoolService } from "../../../shared/services/school.service";
import { ReportService } from "../report.service";
import { HttpclientService } from "../../../shared";
import { Subject } from "rxjs";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	templateUrl: "./studentclassattendancereconciliation.component.html",
})
export class StudentClassAttendanceReconciliationComponent implements OnInit {
	constructor(
		private schoolService: SchoolService,
		private reportService: ReportService,
		private httpclientService: HttpclientService,
		private selectService: SchoolselectorService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		startDate: new Date(),
		endDate: new Date(),
	};
	schoolList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 426;

	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ngOnInit() {
		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(426);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
	}

	Print(format) {
		var component = this;
		this.errorMessage = "";

		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		var strParam = this.GetStrParam();
		var startDate = moment(this.report.startDate).format("MM/DD/YYYY");
		var endDate = moment(this.report.endDate).format("MM/DD/YYYY");

		var reportID = 426;

		if (format == 1) {
			this.isProcessing = true;
			var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);
			result.subscribe(
				(response: any) => {
					component.isProcessing = false;
					window.open(response);
				},
				(error) => {
					component.errorMessage = error;
					component.isProcessing = false;
				}
			);
		} else {
			var remoteUrl = this.httpclientService.remoteServiceName;
			var link =
				remoteUrl +
				"Report/PrintByCSVStudentClassAttendanceReconciliation?startDate=" +
				startDate +
				"&endDate=" +
				endDate +
				"&schoolID=" +
				this.report.SchoolID;
			window.open(link, "_blank");
		}
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam = this.report.SchoolID + "|SchoolID";

		var startDate = moment(this.report.startDate).format("MM/DD/YYYY");
		var endDate = moment(this.report.endDate).format("MM/DD/YYYY");

		strParam += "," + startDate + "|StartDate";
		strParam += "," + endDate + "|EndDate";

		//strParam += ",8C87B20B-5813-4F74-8375-9898FD7B0C74|Imagelogo"

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
